import ExhibitionSlider from './ExhibitionSlider';

export default ExhibitionSlider;
